import storage from "utils/storage";

export const getStoredUser = async () => {
  return await storage.getUserData();
};
